<script setup lang="ts">
// Reusable Footer Component
</script>

<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-brand">
        <img src="@/assets/logo-brand.svg" alt="betPic" class="footer-logo" />
        <p>The social connectivity at the heart of betting.</p>
      </div>
      <div class="footer-links">
        <div class="link-group">
          <h4>Product</h4>
          <router-link to="/">Home</router-link>
          <router-link to="/features">Features</router-link>
        </div>
        <div class="link-group">
          <h4>Contact Us</h4>
<!--          <a href="https://voxbet.com/" target="_blank">Voxbet</a>-->
<!--          <a href="mailto:support@betpic.com">Support</a>-->
          <router-link to="/company">Company</router-link>
          <router-link to="/support">Support</router-link>
        </div>
        <div class="link-group">
          <h4>Legal</h4>
          <router-link to="/privacy-policy">Privacy Policy</router-link>
          <router-link to="/cookie-policy">Cookie Policy</router-link>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>&copy; {{ new Date().getFullYear() }} BetPic. Powered by Voxbet technology.</p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  padding: 80px 5% 40px;
  background: rgba(0, 0, 0, 0.3);
  border-top: 1px solid var(--border-color);
  width: 100%;
  box-sizing: border-box;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 80px;
  margin-bottom: 60px;
}

.footer-logo {
  height: 40px;
  width: auto;
}

.footer-brand p {
  color: var(--text-secondary);
  margin-top: 16px;
  max-width: 250px;
  font-family: var(--font-accent);
  font-size: 0.95rem;
  line-height: 1.5;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  font-family: var(--font-accent);
}

.link-group h4 {
  margin-bottom: 24px;
  font-size: 1rem;
  color: var(--text-primary);
  font-weight: 700;
}

.link-group a {
  display: block;
  color: var(--text-secondary);
  text-decoration: none;
  margin-bottom: 12px;
  transition: color 0.3s ease;
  font-size: 0.95rem;
}

.link-group a:hover {
  color: var(--red-primary);
}

.footer-bottom {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  border-top: 1px solid var(--border-color);
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 5% 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
    text-align: center;
    margin-bottom: 40px;
  }

  .footer-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer-brand p {
    margin: 12px auto 0;
  }

  .footer-links {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    text-align: center;
  }

  .link-group h4 {
    margin-bottom: 12px;
    font-size: 0.9rem;
  }

  .link-group a {
    margin-bottom: 8px;
    font-size: 0.85rem;
  }
}
</style>
